module.exports = __webpack_public_path__ + "img/ИФ-1(А)-030-m.46bcdf8a.png";